import classNames from 'classnames';

import styles from '../../styles/typography/body.module.css';

interface BodyProps {
    children?: React.ReactNode;
    theme?: 'quatre95' | 'periodelibre' | 'dehors' | 'france' | 'mollo' | 'inherit' | null;
    className?: string | null;
    onClick?: () => void;
}

function Body({ children, theme = null, className = null, onClick = null }: BodyProps) {
    return (
        <div
            className={classNames([styles.container, className])}
            data-theme={theme}
            onClick={onClick}
        >
            {children}
        </div>
    );
}

export default Body;
